/**
 * @description 平台模块
 */
import {
  getCourseData,
  getSemesterData,
  getInvalidCourse,
  getAccessAnalyse,
  getSearchAccessAnalyse,
  getOnlineData,
  getOnlineCourseDetail,
  getOnlineUserDetail,
} from '@/api/platform'

const state = () => ({})

const getters = {}
// 同步方法写在这里--对应commit
const mutations = {}
// 异步请求写在这里--对应dispatch
const actions = {
  // 获取学院建设统计情况
  getCourseData({}, data) {
    return new Promise((resolve, reject) => {
      getCourseData(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取平台学期统计
  getSemesterData({}, data) {
    return new Promise((resolve, reject) => {
      getSemesterData(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
    // 获取实时在线数据
    getOnlineData({}, data) {
      return new Promise((resolve, reject) => {
        getOnlineData(data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
      // 获取实时在线课程列表
  getOnlineCourseDetail({}, data) {
    return new Promise((resolve, reject) => {
      getOnlineCourseDetail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
    // 获取实时在线用户列表
    getOnlineUserDetail({}, data) {
      return new Promise((resolve, reject) => {
        getOnlineUserDetail(data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  // 获取无效课程
  getInvalidCourse({}, data) {
    return new Promise((resolve, reject) => {
      getInvalidCourse(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取访问分析
  getAccessAnalyse({}, data) {
    return new Promise((resolve, reject) => {
      getAccessAnalyse(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 中大-搜索获取访问分析
  getSearchAccessAnalyse({}, data) {
    return new Promise((resolve, reject) => {
      getSearchAccessAnalyse(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default { state, getters, mutations, actions }
